export class FeatureFlagConstant {
  public static USE_COMBINED_COMPANY_USERS_VIEW = 'USE_COMBINED_COMPANY_USERS_VIEW';
  public static ADMIN_PROPERTY_UNIT = 'ADMIN_PROPERTY_UNIT';
  public static ADMIN_EVALUATION = 'ADMIN_EVALUATION';
  public static COMMUNITY_FEATURE = 'COMMUNITY_FEATURE';
  public static ADMIN_ASK_AYEN = 'ADMIN_ASK_AYEN';
}
